import { BUTTON_BACKGROUND_APPEARANCES, BUTTON_VARIANTS } from 'cdk-radial';
import { StyledButton, StyledButtonContainer } from './styled';
import { PrimaryButtonProps } from './types';

const PageHeaderTitleWithButtons = ({
  buttons
}: PrimaryButtonProps): React.JSX.Element => (
  <StyledButtonContainer data-testid="page-header-title-with-buttons">
    <StyledButton
      text={buttons.primary.text}
      variant={BUTTON_VARIANTS.PRIMARY}
      backgroundAppearance={BUTTON_BACKGROUND_APPEARANCES.LIGHT}
      onClick={buttons.primary.onClick}
      isLoading={buttons.primary.isLoading}
      style={buttons.primary.style}
    />
  </StyledButtonContainer>
);
export default PageHeaderTitleWithButtons;
